import { rankingList } from "@/mocks/content";

const rankStyles = ["bg-primary-500 text-background-50", "bg-accent-500 text-background-50", "bg-secondary-500 text-background-50"];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-[0.85fr_1.15fr] gap-10 lg:gap-14 items-start">
          <div data-reveal>
            <h2 className="font-heading font-semibold text-2xl md:text-3xl text-foreground-950">
              热看排行：本周关注度的顺序
            </h2>
            <p className="mt-4 text-foreground-600 leading-8">
              排行按「题材热度 + 观众反馈 + 更新节奏」三项综合整理，用进度条呈现相对顺序，
              方便你判断先看哪一部。
            </p>
            <div className="mt-6 p-4 rounded-xl bg-background-100 border border-background-200">
              <div className="flex items-center gap-2 text-secondary-700 text-sm font-medium">
                <i className="ri-information-line" aria-hidden="true"></i>
                关于数据
              </div>
              <p className="mt-2 text-xs text-foreground-600 leading-6">
                进度条数值为编辑整理的示意数据，仅用于比较条目之间的相对关注度，不代表任何平台的官方统计。
              </p>
            </div>
            <div className="mt-6 flex flex-wrap gap-2">
              {["更新节奏稳定", "口碑持续上升", "适合连续追看"].map((t) => (
                <span key={t} className="px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs">
                  {t}
                </span>
              ))}
            </div>
          </div>

          <ol className="space-y-3" data-reveal>
            {rankingList.map((item) => (
              <li
                key={item.rank}
                className="flex items-center gap-4 p-4 rounded-xl bg-background-100 border border-background-200"
              >
                <span
                  className={`w-9 h-9 shrink-0 flex items-center justify-center rounded-lg font-heading font-semibold text-sm ${
                    rankStyles[item.rank - 1] || "bg-background-200 text-foreground-700"
                  }`}
                >
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-3">
                    <h3 className="font-medium text-foreground-900 truncate">{item.title}</h3>
                    <span
                      className={
                        item.trend.startsWith("上升")
                          ? "text-xs text-primary-600 whitespace-nowrap"
                          : item.trend.startsWith("下降")
                          ? "text-xs text-foreground-500 whitespace-nowrap"
                          : "text-xs text-secondary-700 whitespace-nowrap"
                      }
                    >
                      {item.trend}
                    </span>
                  </div>
                  <div className="mt-2 h-1.5 w-full rounded-full bg-background-300/60 overflow-hidden">
                    <div
                      className="h-full rounded-full bg-primary-400"
                      style={{ width: `${item.value}%` }}
                    />
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}